import StratosphereAbi from "@abi/Stratosphere.json";
import { useReadContract } from "wagmi";

const useStratosphere = (account: string) => {
	const { data: tokenId } = useReadContract({
		abi: StratosphereAbi,
		args: [account],
		functionName: "tokenIdOf",
	}) ?? { data: 0 };
	return +tokenId?.toString() === 0
		? { status: "not-found" }
		: { status: "member" };
};

export default useStratosphere;
